"use client";

import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DownloadCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="download-cta" className="relative section-dark overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 opacity-10 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542868/img/france_topographic_map.png)`
    }} />

      <div className={`relative container mx-auto px-4 flex flex-col items-center justify-center min-h-[400px] transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <div className="absolute top-8 right-8 md:right-16 lg:right-24 animate-bounce">
          <div className="bg-accent/20 rounded-full p-4 backdrop-blur-sm">
            <FileDown className="size-8 md:size-10 text-accent" />
          </div>
        </div>

        {}
        <div className="text-center max-w-2xl">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-dark-foreground mb-4">
            Get Your Free France Survival Kit
          </h2>
          <p className="text-lg md:text-xl text-dark-foreground/80 mb-8">
            Unlock insider tips, budget hacks, and essential resources for your French adventure.
          </p>

          {}
          <Button size="lg" className="text-lg md:text-xl px-8 md:px-12 py-6 md:py-8 h-auto shadow-strong hover:shadow-medium transition-all duration-[80ms] ease-[cubic-bezier(0.4,0,0.2,1)] hover:scale-[1.03] active:scale-100 hover:bg-accent-hover active:bg-accent-active">
            <FileDown className="size-6 md:size-7" />
            Download Free PDF Guide
          </Button>

          <p className="text-sm text-dark-foreground/60 mt-4">
            No signup required. Instant access.
          </p>
        </div>
      </div>
    </section>;
}